import type { QueryClient } from '@tanstack/react-query'
import { redirect } from '@tanstack/react-router'
import { Role } from 'types'

import { querySession } from '@api/session/session.queries'

const ensureUserRoleOnRoute = async (queryClient: QueryClient) => {
  try {
    const session = await queryClient.ensureQueryData(querySession())
    if (session.role !== Role.Admin) throw new Error('Unauthorized')
  } catch (error) {
    throw redirect({ to: '/app' })
  }
}

export default ensureUserRoleOnRoute
